
import Vue from 'vue'
import RealTransformer from '@/transformers/workPlan/real'
import errorHandler from '@/utils/errorHandler'

export default (real) => {
	const payload = RealTransformer.send(real)
	const config = {
		headers: {
			'content-type': 'multipart/form-data',
		}
	}

	return errorHandler(Vue.$http.post('workplan/real/', payload, config))
		.then(response => RealTransformer.fetch(response.data))
}


// WEBPACK FOOTER //
// ./src/services/workPlan/sendReal.js